<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de Servicios" icon="fas fa-coins" btn_name="Servicio" @mtdBack="mtdBack"
          @show_modal="mtd_open_modal" @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'"
          :button_new="true" :actions="true" :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
      :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
      <CRow>
        <CCol sm="12">
          <CInput label="Nombre" placeholder="Digite nombre" v-model="service.name" />
        </CCol>
        <CCol sm="12">
          <cSelectForm label="Tipo de Servicio" placeholder="Seleccione tipo de servicio" :options="data_serviceType"
            :value.sync="service.service_type_id" />
        </CCol>
        <CCol sm="12">
          <CInput label="Precio" placeholder="Digite Precio" v-model="service.price" type="number"
            @input="validatePrice" />
        </CCol>
        <CCol sm="12">
          <CInput label="Tiempo de Servicio (hh:mm)" placeholder="Digite el tiempo" v-model="service.time" type="time" />
        </CCol>
        <CCol sm="12">
          <CTextarea label="Descripción" placeholder="Digite Descripción" v-model="service.description"></CTextarea>
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="service.state == 1 ? true : false" color="success" variant="opposite" shape="pill"
            v-bind="labelIcon" />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Servicio'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "service_type_name", label: "Tipo de Servicio", _style: "width:20%;" },
  { key: "price", label: "Precio", _style: "width:20%;" },
  { key: "time", label: "Tiempo de Servicio", _style: "width:20%;" },
  { key: "description", label: "Descripción", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../components/shared/datatable/Table.vue";
import CModalForm from "../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../main";
import { CSwitch, CTextarea } from "@coreui/vue-pro";
import CSwitchVue from "../shared/switch/CSwitch.vue";
import cSelectForm from '../../components/shared/inputs/cSelect.vue';

export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue, cSelectForm },
  data() {
    return {
      prefix: "service",
      fields,
      data: [],
      data_serviceType: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      service: {
        id: "",
        name: "",
        service_type_id: "",
        type_service_name: "",
        price: "",
        time: "00:00",
        company: this.$store.getters.get_company,
        description: "",
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
    };
  },
  computed: {
    cp_button: function () {
      if (this.service.name && this.service.price) {
        return false;
      }
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    this.mtdGetServiceType();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {

          this.data = response.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          console.log(errors);
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdGetServiceType() {
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix + "/byTypeService/" + this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.forEach((element) => {
            this.data_serviceType.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Servicio")
        : (this.modal.title = "Editar Servicio");
      action == "store"
        ? (this.service = {
          id: "",
          name: "",
          price: "",
          time: "00:00",
          service_type_id: "",
          company: this.$store.getters.get_company.id,
          description: "",
          state: "",
        })
        : (this.service = this.service);
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.service,
      })
        .then((response) => {
          let color = "success";
          let message = "";
          if (response.data.state == 1) {
            Swal.fire({
              title: "Servicio ya resgistrado",
              icon: "warning",
            });
          } else {
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              // this.mtd_getdata();
            } else {
              this.data.forEach((element) => {
                if (element.Id == response.data[0].Id) {
                  element.Nombre = response.data[0].Nombre;
                  element.status = response.data[0].status;
                }
                message = "EDITADO CORRECTAMENTE";
              });
              // this.mtd_getdata();
            }
            this.service = {
              id: "",
              name: "",
              price: "",
              time: "00:00",
              service_type_id: "",
              company: this.$store.getters.get_company.id,
              state: "",
            };
            this.mtd_getdata();
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.service = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => { });
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => { });
    },
    changeSwitch: function (payload) {
      this.service.state = payload == true ? 1 : 0;
    },
    validatePrice() {
      let price = this.service.price;
      price.toString();

      if (/[^\d.]/.test(price)) {
        this.service.price = toString().replace(/[^\d.]/g, '');
      }

      const decimalParts = price.split('.');

      if (decimalParts[1] && decimalParts[1].length > 2) {
        decimalParts[1] = decimalParts[1].substring(0, 2);
        price = `${decimalParts[0]}.${decimalParts[1]}`;
      }

      if (decimalParts.length > 2) {
        price = `${decimalParts[0]}.${decimalParts[1]}`;
      }

      if (parseFloat(price) < 0) {
        price = '0';
      }

      this.service.price = price;
    },
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>